import type { TFunction } from 'i18next'

/** 학년 옵션 (빈 문자열 = 미입력). StudentManagement 폼 + 상세 공유. */
export const GRADE_LEVEL_OPTIONS = [
  { value: '', labelKey: 'students.gradeLevel.none' },
  { value: 'preschool', labelKey: 'dashboard.gradeLevel.preschool' },
  { value: 'elementary1', labelKey: 'dashboard.gradeLevel.elementary1' },
  { value: 'elementary2', labelKey: 'dashboard.gradeLevel.elementary2' },
  { value: 'elementary3', labelKey: 'dashboard.gradeLevel.elementary3' },
  { value: 'elementary4', labelKey: 'dashboard.gradeLevel.elementary4' },
  { value: 'elementary5', labelKey: 'dashboard.gradeLevel.elementary5' },
  { value: 'elementary6', labelKey: 'dashboard.gradeLevel.elementary6' },
  { value: 'middle1', labelKey: 'dashboard.gradeLevel.middle1' },
  { value: 'middle2', labelKey: 'dashboard.gradeLevel.middle2' },
  { value: 'middle3', labelKey: 'dashboard.gradeLevel.middle3' },
  { value: 'high', labelKey: 'dashboard.gradeLevel.high' },
  { value: 'university', labelKey: 'dashboard.gradeLevel.university' },
  { value: 'adult', labelKey: 'dashboard.gradeLevel.adult' },
] as const

export const GRADE_LEVEL_ORDER: Record<string, number> = {
  preschool: 1,
  elementary1: 2,
  elementary2: 3,
  elementary3: 4,
  elementary4: 5,
  elementary5: 6,
  elementary6: 7,
  middle1: 8,
  middle2: 9,
  middle3: 10,
  high: 11,
  university: 12,
  adult: 13,
}

export function getGradeLevelLabel(
  gradeLevel: string | null | undefined,
  t: TFunction,
): string {
  if (!gradeLevel) return '-'
  return t(`admin:dashboard.gradeLevel.${gradeLevel}`, { defaultValue: gradeLevel })
}

export function getGenderLabel(gender: string | null | undefined, t: TFunction): string {
  if (gender === 'male') return t('admin:students.form.genderMale')
  if (gender === 'female') return t('admin:students.form.genderFemale')
  return '-'
}
